import {
  GET_USER_UNLOCK_INFO,
  GET_USER_UNLOCK_INFO_SUCCESS,
} from "./actionTypes"

const initialState = {
  unlockCredit: 0,
  unlockCnt: 0,
  loading: false,
  errorMessage: "",
  pctUnlockCredit: 0,
  pctUnlockCnt: 0,
  pctSubscription: "N",
  pctSubscriptionInvoiceOverdueYn: "N",
}

const Unlock = (state = initialState, action) => {
  switch (action.type) {
    case GET_USER_UNLOCK_INFO:
      return {
        ...state,
        // loading: true,
      }
    case GET_USER_UNLOCK_INFO_SUCCESS:
      // console.log("GET_USER_UNLOCK_INFO_SUCCESS : ", action.payload)
      return {
        ...state,
        // loading: false,
        unlockCredit: action.payload.unlockCredit,
        unlockCnt: action.payload.unlockCnt,
        pctUnlockCredit: action.payload.pctUnlockCredit,
        pctUnlockCnt: action.payload.pctUnlockCnt,
        pctSubscription: action.payload.pctSubscription,
        pctSubscriptionInvoiceOverdueYn: action.payload.pctSubscriptionInvoiceOverdueYn,
      }
    default:
      state = { ...state }
      break
  }
  return state
}

export default Unlock